import React, { useEffect } from 'react';
import { useParams } from "react-router-dom";
import '../../style/AllocatedTeamToParticipant.css';
import firebase from '../../firebase';
import { useNavigate } from 'react-router-dom';
import NoSleep from "nosleep.js";  // Import NoSleep.js


export default function AllocatedTeamToParticipant({onNavigate, code: propCode}) {
  const { code: urlCode } = useParams();
  const code = propCode || urlCode;
  const noSleep = new NoSleep();
  const allocatedTeam = localStorage.getItem('allocatedTeam');

  useEffect(() => {
    
    const timeoutId = setTimeout(() => {
      onNavigate('WaitingScreen');
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="AllocatedTeamcontainer text-white ">
      <p className='YouareText'>You're in</p>
      <div className='mt-1'>
        <p className='allocatedteamName'>{allocatedTeam}</p>
      </div>
    </div>
  );
}